export default __webpack_public_path__ + "static/media/AvatarKids-13.169e3b59.png";